import { Injectable } from '@angular/core';
import { Store, StoreConfig, guid } from '@datorama/akita';

export interface AppSidebarState {
	selectedUserId: string;
	isNotificationsExpanded: boolean;
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'ui-sidebar' })
export class AppSidebarStore extends Store<AppSidebarState> {
	constructor() {
		super(
			{ isNotificationsExpanded: true },
			{ name: `ui-app-sidebar-${guid()}` }
		);
	}
}
